import Repository from "./Repository";

const formDataConfig = {
  headers: { "Content-Type": "multipart/form-data" }
};

const ADD_NOTE = "note";
const ADD_COMMENT = "comment";
const ADD_IMAGE_COMMENT = "image-comment";
const MAP = "map";

export default {
  getDesigns(payload) {
    return Repository.get(transformRoute(""), payload);
  },

  uploadDesign(payload) {
    return Repository.post(transformRoute(""), payload);
  },

  deleteDesign(payload) {
    return Repository.delete(transformRoute(""), payload);
  },

  addNote(payload) {
    return Repository.post(transformRoute(ADD_NOTE), payload);
  },

  addComment(payload) {
    return Repository.post(transformRoute(ADD_COMMENT), payload);
  },

  addImageComment(payload) {
    return Repository.post(
      transformRoute(ADD_IMAGE_COMMENT),
      payload,
      formDataConfig
    );
  },

  mapDesigns(payload) {
    return Repository.post(transformRoute(MAP), payload, formDataConfig);
  }
};

const transformRoute = route => {
  return `/task-manager/design/${route}`;
};
